// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1e4Dr","inner":"Footer_inner__2CPbL"};